import React, { useState, useEffect } from 'react';
import { get, post, put, api, getBranchOwner, consts } from "@config";
import { Modal } from 'react-bootstrap';
import SweetAlert from "react-bootstrap-sweetalert";
import {
    StyledCard,
    StyledCardHeader,
    SectionTitle,
    StyledInputGroup,
    ActionButton,
    LayoutGrid,
    ScreenContainer,
    ScreenContent,
    HeroHeader,
    HeroHeaderTitle,
    HeroIcon,
    HelperButton
} from '../emit/components/styles';
import ActivityList from './components/ActivityList';
import NatureOperationList from './components/NatureOperationList';

export default function ConfigNfse() {
    const [initializing, setInitializing] = useState(true);
    const branch = getBranchOwner();

    useEffect(() => {
        if (!branch) return;
        
        const hasPermission = branch.permissions && branch.permissions.nfse === 3;
        
        if (!hasPermission) {
            window.location.href = '/nfse/enable';
        } else {
            setInitializing(false);
        }
    }, [branch]);

    const [config, setConfig] = useState({
        auth_token: 0,
        municipal_registry: '',
        user_access: '',
        pwd_access: '',
        rps_serie: 1,
        rps_number: 1,
        print_format: 'Detalhado',
        // [MODULE: IBS_CBS] Configuracoes Reforma Tributaria (Obrigatorio Ago/2026+)
        ibs_cbs_aliquota_ibs_uf: '0.10',
        ibs_cbs_aliquota_ibs_mun: '0.05',
        ibs_cbs_aliquota_cbs: '0.90',
        ibs_cbs_cind_op: '000000',
        ibs_cbs_cst_ibscbs: '000',
        ibs_cbs_cclass_trib: '000001',
        ibs_cbs_fin_nfse: 0,
        ibs_cbs_ind_dest: 0,
        // [MODULE: DPS] Configuracoes Padrao Nacional
        channel_override: 'auto',
        dps_token: '',
        dps_environment: 'homologacao',
        is_national_standard_city: false,
    });
    const [instructions, setInstructions] = useState(false);
    const [loading, setLoading] = useState(true);
    const [alertSuccess, setAlertSuccess] = useState(false);
    const [refreshingToken, setRefreshingToken] = useState(false);
    const [tokenStatus, setTokenStatus] = useState(null);
    const [showTokenInfo, setShowTokenInfo] = useState(false);

    useEffect(() => {
        const branch = getBranchOwner();
        const payload = (resp) => {
            if (window.location.search.includes("instructions")) {
                setInstructions(true);
            }
            resp.municipal_registry = branch.company.municipal_registry || "";
            setConfig(resp);
            setLoading(false);
        };
        const errPayload = err => setLoading(false);
        get(`${api.nfse.config}?branch_owner=${branch.id}`, payload, errPayload);
    }, []);

    if (initializing) {
        return null;
    }

    const changeField = (e) => {
        const { name, value } = e.target;
        setConfig(prev => ({ ...prev, [name]: value }));
    };

    const parseErrorMessage = (error) => {
        if (!error) {
            return 'Não foi possível atualizar o token automaticamente.';
        }
        if (error.responseText) {
            try {
                const payload = JSON.parse(error.responseText);
                return (
                    payload.detail ||
                    payload.error ||
                    payload.message ||
                    'Não foi possível atualizar o token automaticamente.'
                );
            } catch (err) {
                return 'Não foi possível atualizar o token automaticamente.';
            }
        }
        if (error.status === 404) {
            return 'Configuração não encontrada no InvoiCy para esta filial.';
        }
        return 'Não foi possível atualizar o token automaticamente.';
    };

    const refreshAuthToken = () => {
        if (!config.id || refreshingToken) {
            return;
        }

        const branch = getBranchOwner();
        const url = `${api.nfse.config}${config.id}/refresh-auth-token/?branch_owner=${branch.id}`;

        setRefreshingToken(true);
        setTokenStatus(null);

        post(url, {}, (resp) => {
            const retrievedToken = resp && resp.auth_token;

            if (retrievedToken && retrievedToken !== '0') {
                setConfig((prev) => ({ ...prev, auth_token: retrievedToken }));
                setTokenStatus({ type: 'success', message: 'Token sincronizado com os dados do InvoiCy.' });
            } else {
                setTokenStatus({
                    type: 'error',
                    message: 'O InvoiCy não retornou uma chave válida. Verifique se a filial está cadastrada e liberada.',
                });
            }

            setRefreshingToken(false);
        }, (err) => {
            const message = parseErrorMessage(err);
            setTokenStatus({ type: 'error', message });
            setRefreshingToken(false);
        });
    };

    const save = () => {
        setLoading(true);
        const branch = getBranchOwner();
        const payload = (resp) => {
            if (config.municipal_registry !== branch.company.municipal_registry) {
                branch.company.municipal_registry = config.municipal_registry;
                window.localStorage.setItem(consts.CURRENT_BRANCH, JSON.stringify(branch));
            }
            setConfig(resp);
            setAlertSuccess(true);
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        };
        const errPayload = err => setLoading(false);

        if (config.id) {
            const url = `${api.nfse.config}${config.id}/?branch_owner=${branch.id}`;
            put(url, config, payload, errPayload);
        } else {
            const url = `${api.nfse.config}?branch_owner=${branch.id}`;
            post(url, config, payload, errPayload);
        }
    };

    return (
        <ScreenContainer>
            <ScreenContent style={{ maxWidth: '1000px' }}>
                <HeroHeader>
                    <HeroHeaderTitle>
                        <HeroIcon>
                            <i className="fas fa-cogs"></i>
                        </HeroIcon>
                        <div>
                            <h1 className="m-0" style={{ fontWeight: 800, fontSize: '1.75rem', color: '#101828' }}>Configurações NFS-e</h1>
                            <span style={{ color: '#475467', fontSize: '0.95rem', fontWeight: 500 }}>
                                Ajuste os parâmetros necessários para emissão{' '}
                                <i style={{ color: "#0088cc", cursor: 'pointer' }} className='fas fa-question-circle ms-2' onClick={() => window.location.href = '/nfse/settings?instructions'} />
                            </span>
                        </div>
                    </HeroHeaderTitle>
                </HeroHeader>

                <Modal show={instructions} onHide={() => window.location.href = '/nfse/settings'} centered>
                    <Modal.Header closeButton>
                        <h4 className='m-0' style={{ fontWeight: 700 }}>Instruções de Configuração</h4>
                    </Modal.Header>
                    <Modal.Body style={{ fontSize: '1.05rem', color: '#475467' }}>
                        <p className="mb-4">Para emissão da nota fiscal de serviço é necessário possuir:</p>
                        <ul style={{ display: 'flex', flexDirection: 'column', gap: '12px', listStyle: 'none', padding: 0 }}>
                            <li><i className="fas fa-check-circle text-success me-2"></i> Cnae de Serviço válido</li>
                            <li><i className="fas fa-check-circle text-success me-2"></i> Inscrição Municipal registrada</li>
                            <li><i className="fas fa-check-circle text-success me-2"></i> Certificado Digital configurado na filial</li>
                            <li><i className="fas fa-check-circle text-success me-2"></i> Usuário e senha de acesso da prefeitura (se exigido)</li>
                        </ul>
                    </Modal.Body>
                </Modal>

                <StyledCard>
                    <StyledCardHeader>
                        <div>
                            <SectionTitle><i className="fas fa-shield-alt"></i> Credenciais e Acesso</SectionTitle>
                            <span className="text-secondary" style={{ fontSize: '0.9rem' }}>Dados logísticos e de integração</span>
                        </div>
                    </StyledCardHeader>

                    <LayoutGrid style={{ marginBottom: '24px', alignItems: 'end' }}>
                        <StyledInputGroup>
                            <label>Inscrição Municipal</label>
                            <input disabled={loading} name='municipal_registry' value={config.municipal_registry || ''} onChange={changeField} />
                        </StyledInputGroup>
                        <StyledInputGroup style={{ gridColumn: 'span 2' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                <label className='m-0'>Token de autenticação</label>
                                <button
                                    type="button"
                                    onClick={() => setShowTokenInfo(true)}
                                    style={{
                                        background: 'transparent',
                                        border: 'none',
                                        padding: 0,
                                        color: '#0088cc',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}
                                    title="Quando usar?"
                                >
                                    <i className="fas fa-info-circle" />
                                </button>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    gap: '12px',
                                    flexWrap: 'wrap',
                                    alignItems: 'center'
                                }}
                            >
                                <input
                                    style={{ flex: '1 1 260px', minWidth: '220px' }}
                                    disabled={loading || refreshingToken}
                                    name='auth_token'
                                    value={config.auth_token || ''}
                                    onChange={changeField}
                                />
                                <ActionButton
                                    type="button"
                                    variant="secondary"
                                    disabled={loading || refreshingToken || !config.id}
                                    onClick={refreshAuthToken}
                                    title={!config.id ? 'Salve as configurações antes de carregar automaticamente.' : ''}
                                    style={{
                                        minWidth: '150px',
                                        height: '44px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    {refreshingToken ? <i className="fas fa-circle-notch fa-spin" /> : <i className="fas fa-sync" />}
                                    {refreshingToken ? 'Sincronizando' : 'Atualizar'}
                                </ActionButton>
                            </div>
                            {tokenStatus && (
                                <small
                                    style={{
                                        color: tokenStatus.type === 'error' ? '#D92D20' : '#039855',
                                        fontWeight: 500,
                                        marginTop: '6px',
                                        display: 'block'
                                    }}
                                >
                                    {tokenStatus.message}
                                </small>
                            )}
                        </StyledInputGroup>
                        <StyledInputGroup>
                            <label>Modelo de Espelho (Impressão)</label>
                            <select disabled={loading} name='print_format' value={config.print_format || 'Detalhado'} onChange={changeField}>
                                <option value="Detalhado">Detalhado</option>
                                <option value="Detalhado Antigo">Detalhado Antigo</option>
                                <option value="Cupom">Cupom</option>
                                <option value="Uberlândia">Uberlândia</option>
                                <option value="Nacional">Nacional</option>
                            </select>
                        </StyledInputGroup>
                        <StyledInputGroup>
                            <label>Usuário de acesso</label>
                            <input disabled={loading} name='user_access' value={config.user_access || ''} onChange={changeField} />
                        </StyledInputGroup>
                        <StyledInputGroup>
                            <label>Senha de acesso</label>
                            <input disabled={loading} type='password' name='pwd_access' value={config.pwd_access || ''} onChange={changeField} />
                        </StyledInputGroup>
                    </LayoutGrid>

                    <StyledCardHeader>
                        <SectionTitle><i className="fas fa-list-ol"></i> Numeração RPS e Parâmetros de Emissão</SectionTitle>
                    </StyledCardHeader>

                    <LayoutGrid style={{ marginBottom: '24px' }}>
                        <StyledInputGroup>
                            <label>Série atual da RPS</label>
                            <input disabled={loading} type="number" name='rps_serie' value={config.rps_serie || 1} onChange={changeField} />
                        </StyledInputGroup>
                        <StyledInputGroup>
                            <label>Número atual da RPS</label>
                            <input disabled={loading} type="number" name='rps_number' value={config.rps_number || 1} onChange={changeField} />
                        </StyledInputGroup>
                        <StyledInputGroup>
                            <label>Optante pelo Simples Nacional</label>
                            <select disabled={loading} name='rps_opt_sn' value={config.rps_opt_sn != null ? config.rps_opt_sn : 1} onChange={changeField}>
                                <option value={1}>Sim</option>
                                <option value={2}>Não</option>
                            </select>
                        </StyledInputGroup>
                        {(config.rps_opt_sn == 1 || config.rps_opt_sn === '1') && (
                            <StyledInputGroup>
                                <label>
                                    Regime Especial de Tributação (RegEspTrib)
                                    <i className="fas fa-info-circle ms-1 text-muted"
                                        title="Define como o ISS é recolhido. Use 6 se o ISS é pago dentro do Simples. Use 8 se o ISS é recolhido fora do Simples (separado). Dúvida: consulte seu contador."
                                        style={{ cursor: 'help', fontSize: '0.85rem' }} />
                                </label>
                                <select
                                    disabled={loading}
                                    name='reg_esp_trib'
                                    value={config.reg_esp_trib != null ? config.reg_esp_trib : 6}
                                    onChange={changeField}
                                    id="nfse-reg-esp-trib"
                                >
                                    <option value={6}>6 – ISS recolhido pelo Simples Nacional</option>
                                    <option value={8}>8 – ISS recolhido fora do Simples Nacional</option>
                                    <option value={7}>7 – ME/EPP com tributação própria de ISS</option>
                                    <option value={1}>1 – Sem regime especial</option>
                                    <option value={2}>2 – Estimativa</option>
                                    <option value={3}>3 – Sociedade de Profissionais</option>
                                    <option value={4}>4 – Cooperativa</option>
                                </select>
                            </StyledInputGroup>
                        )}
                        <StyledInputGroup>
                            <label>
                                Finalidade da NFS-e (finNFSe)
                                <i className="fas fa-info-circle ms-1 text-muted"
                                    title='Indicador da finalidade da emissão. 0 = NFS-e regular (caso padrão).'
                                    style={{ cursor: 'help', fontSize: '0.85rem' }} />
                            </label>
                            <select
                                disabled={loading}
                                name='ibs_cbs_fin_nfse'
                                value={config.ibs_cbs_fin_nfse !== undefined && config.ibs_cbs_fin_nfse !== null ? config.ibs_cbs_fin_nfse : 0}
                                onChange={changeField}
                            >
                                <option value={0}>0 - NFS-e regular</option>
                            </select>
                        </StyledInputGroup>
                        <StyledInputGroup>
                            <label>
                                Destinatário do Serviço (indDest)
                                <i className="fas fa-info-circle ms-1 text-muted"
                                    title='0 = o tomador é o adquirente e o destinatário do serviço (caso padrão). 1 = destinatário é diferente do tomador/adquirente.'
                                    style={{ cursor: 'help', fontSize: '0.85rem' }} />
                            </label>
                            <select
                                disabled={loading}
                                name='ibs_cbs_ind_dest'
                                value={config.ibs_cbs_ind_dest !== undefined && config.ibs_cbs_ind_dest !== null ? config.ibs_cbs_ind_dest : 0}
                                onChange={changeField}
                            >
                                <option value={0}>0 - Tomador = adquirente = destinatário</option>
                                <option value={1}>1 - Destinatário diferente do tomador/adquirente</option>
                            </select>
                        </StyledInputGroup>
                    </LayoutGrid>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #EAECF0', paddingTop: '24px', marginTop: '32px' }}>
                        <ActionButton variant="primary" disabled={loading} onClick={save} style={{ minWidth: '180px' }}>
                            {loading ? <i className="fas fa-circle-notch fa-spin"></i> : <i className="fas fa-save"></i>}
                            {loading ? 'Salvando...' : 'Salvar Configurações'}
                        </ActionButton>
                    </div>

                    {/* [SECTION: IBS_CBS] Reforma Tributaria */}
                    <div style={{ borderTop: '2px solid #F79009', marginTop: '40px', paddingTop: '32px' }}>
                        <StyledCardHeader>
                            <div>
                                <SectionTitle>
                                    <i className="fas fa-balance-scale" style={{ color: '#F79009' }}></i>{' '}
                                    IBS e CBS — Reforma Tributária
                                    <span style={{
                                        display: 'inline-block',
                                        marginLeft: '12px',
                                        background: '#FEF3C7',
                                        color: '#92400E',
                                        fontSize: '0.72rem',
                                        fontWeight: 700,
                                        padding: '2px 8px',
                                        borderRadius: '20px',
                                        letterSpacing: '0.03em',
                                        verticalAlign: 'middle',
                                    }}>
                                        Obrigatório a partir de 01/08/2026
                                    </span>
                                </SectionTitle>
                                <span className="text-secondary" style={{ fontSize: '0.9rem' }}>
                                    Alíquotas padrão da NT 007/2026 usadas no cálculo de cada nota emitida.
                                    Durante 2026, os valores de teste são: CBS 0,90% · IBS UF 0,10% · IBS Mun 0,05%.
                                </span>
                            </div>
                        </StyledCardHeader>

                        <LayoutGrid style={{ marginBottom: '12px' }}>
                            <StyledInputGroup>
                                <label>
                                    Alíquota IBS Estadual (%)
                                    <i className="fas fa-info-circle ms-1 text-muted"
                                        title="Parcela estadual do IBS. Padrão 2026: 0,10%"
                                        style={{ cursor: 'help', fontSize: '0.85rem' }} />
                                </label>
                                <input
                                    disabled
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    name='ibs_cbs_aliquota_ibs_uf'
                                    value={config.ibs_cbs_aliquota_ibs_uf || '0.10'}
                                    onChange={changeField}
                                    placeholder="0.10"
                                />
                            </StyledInputGroup>

                            <StyledInputGroup>
                                <label>
                                    Alíquota IBS Municipal (%)
                                    <i className="fas fa-info-circle ms-1 text-muted"
                                        title="Parcela municipal do IBS. Padrão 2026: 0,05%"
                                        style={{ cursor: 'help', fontSize: '0.85rem' }} />
                                </label>
                                <input
                                    disabled
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    name='ibs_cbs_aliquota_ibs_mun'
                                    value={config.ibs_cbs_aliquota_ibs_mun || '0.05'}
                                    onChange={changeField}
                                    placeholder="0.05"
                                />
                            </StyledInputGroup>

                            <StyledInputGroup>
                                <label>
                                    Alíquota CBS Federal (%)
                                    <i className="fas fa-info-circle ms-1 text-muted"
                                        title="Contribuição sobre Bens e Serviços. Padrão 2026: 0,90%"
                                        style={{ cursor: 'help', fontSize: '0.85rem' }} />
                                </label>
                                <input
                                    disabled
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    name='ibs_cbs_aliquota_cbs'
                                    value={config.ibs_cbs_aliquota_cbs || '0.90'}
                                    onChange={changeField}
                                    placeholder="0.90"
                                />
                            </StyledInputGroup>

                            <StyledInputGroup>
                                <label>
                                    cIndOp (Indicador da Operação)
                                    <i className="fas fa-info-circle ms-1 text-muted"
                                        title='Código indicador da operação de fornecimento (tabela "código indicador de operação" da NT 007/2026). Confirme o valor correto com o contador/Migrate — o default "000000" é apenas um placeholder técnico.'
                                        style={{ cursor: 'help', fontSize: '0.85rem' }} />
                                </label>
                                <input
                                    disabled={loading}
                                    type="text"
                                    name='ibs_cbs_cind_op'
                                    value={config.ibs_cbs_cind_op || '000000'}
                                    onChange={changeField}
                                    maxLength={6}
                                    placeholder="000000"
                                />
                            </StyledInputGroup>

                            <StyledInputGroup>
                                <label>
                                    CSTIBSCBS
                                    <i className="fas fa-info-circle ms-1 text-muted"
                                        title='Código de Situação Tributária do IBS e da CBS (Anexo VII da NT 007/2026). Padrão: 000 (tributação integral/normal). Confirme com o contador/Migrate.'
                                        style={{ cursor: 'help', fontSize: '0.85rem' }} />
                                </label>
                                <input
                                    disabled={loading}
                                    type="text"
                                    name='ibs_cbs_cst_ibscbs'
                                    value={config.ibs_cbs_cst_ibscbs || '000'}
                                    onChange={changeField}
                                    maxLength={3}
                                    placeholder="000"
                                />
                            </StyledInputGroup>

                            <StyledInputGroup>
                                <label>
                                    Classificação Tributária (cClassTrib)
                                    <i className="fas fa-info-circle ms-1 text-muted"
                                        title='Anexo VIII da NT 007/2026. Padrão: 000001'
                                        style={{ cursor: 'help', fontSize: '0.85rem' }} />
                                </label>
                                <input
                                    disabled={loading}
                                    type="text"
                                    name='ibs_cbs_cclass_trib'
                                    value={config.ibs_cbs_cclass_trib || '000001'}
                                    onChange={changeField}
                                    maxLength={10}
                                    placeholder="000001"
                                />
                            </StyledInputGroup>
                        </LayoutGrid>

                        <div style={{
                            background: '#FFFBEB',
                            border: '1px solid #FDE68A',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            fontSize: '0.875rem',
                            color: '#78350F',
                            marginTop: '8px',
                            marginBottom: '24px',
                        }}>
                            <i className="fas fa-exclamation-triangle me-2" style={{ color: '#F59E0B' }}></i>
                            <strong>Atenção:</strong> As alíquotas acima são usadas automaticamente em todas as notas emitidas por esta filial.
                            Confirme com o seu contador os valores corretos para o seu regime tributário antes de alterar.
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <ActionButton variant="primary" disabled={loading} onClick={save} style={{ minWidth: '180px' }}>
                                {loading ? <i className="fas fa-circle-notch fa-spin"></i> : <i className="fas fa-save"></i>}
                                {loading ? 'Salvando...' : 'Salvar Configurações'}
                            </ActionButton>
                        </div>
                    </div>
                    {/* [/SECTION: IBS_CBS] */}

                    {/* [SECTION: DPS] Canal de Emissao Padrao Nacional - Secao oculta */}
                    {false && (
                    <div style={{ borderTop: '2px solid #1D4ED8', marginTop: '40px', paddingTop: '32px' }}>
                        <StyledCardHeader>
                            <div>
                                <SectionTitle>
                                    <i className="fas fa-network-wired" style={{ color: '#1D4ED8' }}></i>{' '}
                                    Canal de Emissão — Padrão Nacional (DPS)
                                    <span style={{
                                        display: 'inline-block',
                                        marginLeft: '12px',
                                        background: '#DBEAFE',
                                        color: '#1E3A8A',
                                        fontSize: '0.72rem',
                                        fontWeight: 700,
                                        padding: '2px 8px',
                                        borderRadius: '20px',
                                        letterSpacing: '0.03em',
                                        verticalAlign: 'middle',
                                    }}>
                                        Obrigatório a partir de 03/08/2026
                                    </span>
                                </SectionTitle>
                                <span className="text-secondary" style={{ fontSize: '0.9rem' }}>
                                    Configure o canal de emissão para municípios que aderiram ao Padrão Nacional (DPS).
                                    No modo <strong>Automático</strong>, o sistema detecta e roteia a emissão pelo canal correto.
                                </span>
                            </div>
                        </StyledCardHeader>

                        <LayoutGrid style={{ marginBottom: '12px' }}>
                            <StyledInputGroup>
                                <label>
                                    Canal de Emissão
                                    <i className="fas fa-info-circle ms-1 text-muted"
                                       title="Auto: detecta pelo município. force_rps: sempre ABRASF. force_dps: sempre Padrão Nacional."
                                       style={{ cursor: 'help', fontSize: '0.85rem' }} />
                                </label>
                                <select
                                    disabled={loading}
                                    name='channel_override'
                                    value={config.channel_override || 'auto'}
                                    onChange={changeField}
                                    id="nfse-channel-override"
                                >
                                    <option value="auto">Automático (recomendado)</option>
                                    <option value="force_rps">Forçar RPS (legado ABRASF)</option>
                                    <option value="force_dps">Forçar DPS (Padrão Nacional)</option>
                                </select>
                            </StyledInputGroup>

                            <StyledInputGroup>
                                <label>
                                    Ambiente DPS
                                    <i className="fas fa-info-circle ms-1 text-muted"
                                       title="Homologação para testes. Produção para emissões reais."
                                       style={{ cursor: 'help', fontSize: '0.85rem' }} />
                                </label>
                                <select
                                    disabled={loading}
                                    name='dps_environment'
                                    value={config.dps_environment || 'homologacao'}
                                    onChange={changeField}
                                    id="nfse-dps-environment"
                                >
                                    <option value="homologacao">Homologação</option>
                                    <option value="producao">Produção</option>
                                </select>
                            </StyledInputGroup>

                            <StyledInputGroup>
                                <label>
                                    Token DPS (Ambiente Nacional)
                                    <i className="fas fa-info-circle ms-1 text-muted"
                                       title="Chave de acesso emitida pela SEFAZ/RFB para o Ambiente Nacional. Necessário apenas quando o canal for DPS."
                                       style={{ cursor: 'help', fontSize: '0.85rem' }} />
                                </label>
                                <input
                                    disabled={loading}
                                    type="password"
                                    name='dps_token'
                                    value={config.dps_token || ''}
                                    onChange={changeField}
                                    placeholder="Cole aqui o token DPS fornecido pela SEFAZ"
                                    id="nfse-dps-token"
                                />
                            </StyledInputGroup>
                            <StyledInputGroup>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                    <input
                                        disabled={loading}
                                        type="checkbox"
                                        checked={!!config.is_national_standard_city}
                                        onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            setConfig(prev => ({ ...prev, is_national_standard_city: isChecked }));
                                        }}
                                        id="nfse-is-national-standard-city"
                                    />
                                    Município já aderiu ao Padrão Nacional
                                    <i className="fas fa-info-circle ms-1 text-muted"
                                       title='Marque somente após CONFIRMAR (com a prefeitura/Migrate) que o município desta filial já aceita NFS-e no Padrão Nacional. No modo "Automático", isso faz o sistema rotear a emissão para DPS em vez de RPS legado.'
                                       style={{ cursor: 'help', fontSize: '0.85rem' }} />
                                </label>
                            </StyledInputGroup>
                        </LayoutGrid>

                        <div style={{
                            background: '#EFF6FF',
                            border: '1px solid #BFDBFE',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            fontSize: '0.875rem',
                            color: '#1E3A8A',
                            marginTop: '8px',
                            marginBottom: '24px',
                        }}>
                            <i className="fas fa-info-circle me-2" style={{ color: '#3B82F6' }}></i>
                            <strong>Informação:</strong> No modo "Automático", o sistema detecta se o município do prestador
                            já aderiu ao Padrão Nacional e roteia automaticamente para DPS ou RPS.
                            O Token DPS é exigido apenas quando o canal for DPS (forçado ou automático com município Nacional).
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <ActionButton variant="primary" disabled={loading} onClick={save} style={{ minWidth: '180px' }}>
                                {loading ? <i className="fas fa-circle-notch fa-spin"></i> : <i className="fas fa-save"></i>}
                                {loading ? 'Salvando...' : 'Salvar Configurações'}
                            </ActionButton>
                        </div>
                    </div>
                    )}
                    {/* [/SECTION: DPS] */}

                    <ActivityList />
                    <NatureOperationList />

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '32px', paddingTop: '24px', borderTop: '1px solid #EAECF0' }}>
                      <ActionButton variant="secondary" onClick={() => window.location.href = '/nfse'} style={{ minWidth: '180px' }}>
                        <i className="fas fa-rocket"></i> Ir para o Emissor
                      </ActionButton>
                    </div>
                </StyledCard>

                <Modal show={showTokenInfo} onHide={() => setShowTokenInfo(false)} centered>
                    <Modal.Header closeButton>
                        <h4 className='m-0' style={{ fontWeight: 700 }}>Quando atualizar o token?</h4>
                    </Modal.Header>
                    <Modal.Body style={{ color: '#475467', fontSize: '0.98rem' }}>
                        <p>Use o botão <strong>Atualizar</strong> para sincronizar a chave primária diretamente do InvoiCy quando:</p>
                        <ul style={{ paddingLeft: '18px', marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <li>o campo estiver vazio ou com valor "0" após cadastrar a filial;</li>
                            <li>o cancelamento da NFS-e retornar erro por token ausente ou inválido (ex.: código 412);</li>
                            <li>o suporte da prefeitura solicitar a chave atualizada para o Ambiente Nacional.</li>
                        </ul>
                        <p className='mt-3 mb-0'>Se a chave continuar indisponível, valide se o CNPJ foi habilitado no InvoiCy ou abra um chamado com o nosso suporte.</p>
                    </Modal.Body>
                </Modal>

                <SweetAlert
                    show={alertSuccess}
                    success
                    title="Configurações atualizadas!"
                    showConfirm={false}
                />
            </ScreenContent>
        </ScreenContainer>
    );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/config/index.jsx